import React from 'react';
import {useTranslation} from 'react-i18next';
import {ECONOMICS_COLUMNS} from './ClientEconomicsRow';

/**
 * Encabezado de la vista «Economía» del Listado 2.1. Misma barra que el de la vista Resumen
 * (`.cv2-head`), con la grilla de la vista (`.cv2-screen.-eco .cv2-grid`): la primera celda va sin
 * título por la misma razón que allá (el nombre del cliente se identifica solo) y la última es la
 * del ⋮. Cada celda lleva la clase de su columna para ocultarse en el MISMO corte que sus datos.
 */
export function ClientsEconomicsHeader() {
    const {t} = useTranslation();
    return (
        <div className="cv2-head cv2-grid" data-testid="cv2-eco-head">
            <div className="cv2-head__cell"/>
            {ECONOMICS_COLUMNS.map((column) => (
                <div key={column.key} className={`cv2-head__cell cv2-eco-col-${column.key}`}>
                    {t(column.labelKey)}
                </div>
            ))}
            <div className="cv2-head__cell cv2-eco-col-cta"/>
            <div className="cv2-head__cell"/>
        </div>
    );
}

/**
 * Los rótulos de cada dato cuando la fila se apila (sin encabezado). Mismos textos que el
 * encabezado, como custom properties sobre `.cv2-screen` (patrón `stackedLabels`).
 */
export function economicsStackedLabels(t) {
    return ECONOMICS_COLUMNS.reduce((labels, column) => ({
        ...labels,
        [`--cv2-label-eco-${column.key}`]: JSON.stringify(t(column.labelKey)),
    }), {});
}

export default ClientsEconomicsHeader;
